import { Paper } from "@mui/material";

export default function GlassCard({ sx, ...props }) {
  return (
    <Paper
      {...props}
      elevation={0}
      sx={{
        borderRadius: 2,
        border: "1px solid rgba(255,255,255,0.1)",
        background:
          "linear-gradient(180deg, rgba(255,255,255,0.06), rgba(255,255,255,0.03))",
        backdropFilter: "blur(18px)",
        boxShadow:
          "0 24px 80px rgba(0,0,0,0.34), inset 0 1px 0 rgba(255,255,255,0.06)",
        ...sx,
      }}
    />
  );
}
